import React from 'react';
import ReactDOM from 'react-dom/client';
import './App.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
// Force rebuild Sun Nov 23 02:25:36 IST 2025
// Rebuild 1763881598
// Force rebuild 1763886336
